import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
    position: absolute;
    transform: translate(-50%, -100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: ${({ isDragging }) => isDragging ? 'grabbing' : 'grab'}; /* ✅ cursor changes */
    user-select: none;
    transition: transform 0.1s ease;

    /* ✅ scale up while dragging */
    ${({ isDragging }) => isDragging && `
        transform: translate(-50%, -110%) scale(1.2);
        filter: drop-shadow(0 8px 16px rgba(0,0,0,0.4));
    `}
`;

const Pin = styled.div`
    width: 28px;
    height: 28px;
    background-color: ${({ isDragging }) => isDragging ? '#c0392b' : '#e74c3c'};
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    border: 3px solid #fff;
    box-shadow: 0 2px 6px rgba(0,0,0,0.4);
    transition: background-color 0.2s ease;
`;

const Label = styled.div`
    margin-top: 6px;
    background: white;
    padding: 3px 7px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
`;

const Marker = ({ text, draggable, onDragStart, onDrag, onDragEnd, isDragging }) => {

    const handleMouseDown = (e) => {
        if (!draggable) return;
        e.stopPropagation(); // ✅ prevent map from also dragging
        onDragStart && onDragStart(e);

        const handleMouseUp = () => {
            onDragEnd && onDragEnd(e);
            window.removeEventListener('mouseup', handleMouseUp);
        };
        window.addEventListener('mouseup', handleMouseUp);
    };

    return (
        <Wrapper
            isDragging={isDragging}
            onMouseDown={handleMouseDown}
        >
            <Pin isDragging={isDragging} />
            {text && <Label>{text}</Label>}
        </Wrapper>
    );
};

Marker.defaultProps = {
    draggable: false,
    onDragStart: null,
    onDrag: null,
    onDragEnd: null,
    isDragging: false,
    text: '',
};

Marker.propTypes = {
    text: PropTypes.string,
    draggable: PropTypes.bool,
    onDragStart: PropTypes.func,
    onDrag: PropTypes.func,
    onDragEnd: PropTypes.func,
    isDragging: PropTypes.bool,
};

export default Marker;